/** The strip's height: one row of tabs, before its bottom rule. */
export const TOOLBAR_MATERIAL_TABS_HEIGHT = 48;
